import { render, staticRenderFns } from "./PTableConfirm.vue?vue&type=template&id=c79c4e16"
import script from "./PTableConfirm.vue?vue&type=script&lang=js"
export * from "./PTableConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports